const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

const InvoiceApiService = {
    // Method for handling the signup API call
    Add : async (data) => {
      try {
        const apiEndpoint = `${baseUrl}Invoice/AddInvoice`; // Complete URL for the signup endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data), // Convert data to JSON
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Add Invoice error:', error);
        throw new Error('Network error');
      }
    },
  
    Get: async (data) => {
      try {
        const apiEndpoint = `${baseUrl}Invoice/Get`; // Complete URL for the test endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'GET', // Correctly capitalized method
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },

    GetLastPaidInvoice: async (userId) => {
      try {
        const apiEndpoint = `${baseUrl}Invoice/GetLastPaidInvoice/${userId}`; // Complete URL for the test endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'GET', // Correctly capitalized method
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },

    GetLastUnPaidInvoice: async (userId) => {
      try {
        const apiEndpoint = `${baseUrl}Invoice/GetLastUnPaidInvoice/${userId}`; // Complete URL for the test endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'GET', // Correctly capitalized method
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },

    Update: async (data) => {
      try {
        const apiEndpoint = `${baseUrl}Invoice/Update`; // Complete URL for the signup endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data), // Convert data to JSON
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Update Invoice error:', error);
        throw new Error('Network error');
      }
    },

    Delete: async (id) => {
      try {
          const apiEndpoint = `${baseUrl}Invoice/Delete/${id}`;
  
          const response = await fetch(apiEndpoint, {
              method: 'DELETE',
              headers: {
                  'Content-Type': 'application/json',
              },
          });
  
          if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.message || 'Error occurred while deleting invoice');
          }
  
          const result = await response.json();
          return result;
      } catch (error) {
          console.error('Delete Invoice error:', error);
          throw new Error('Network error');
      }
  }
  
    
  };
  
  export default InvoiceApiService;
  